<template>
  <div id="np-recognition-list">
    <v-card class="main-card elevation-5">
      <v-card-title class="header-container">
        <div class="header-title">
          <h2 class="text-h4 font-weight-bold">{{ PageTitle }}</h2>
          <div class="header-bar"></div>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          @click.prevent="refreshPageData"
          color="success"
          min-width="110"
          rounded
          elevation="2"
          class="font-weight-bold px-4 py-4 text-capitalize action-btn"
        >
          <v-icon left>mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </v-card-title>

      <v-card-text class="pb-0">
        <v-container class="stats-container">
          <v-row wrap>
            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card
                  class="stat-card deadline-card skeleton-card"
                  v-if="CardLoadingFlag"
                  min-height="210"
                  elevation="5"
                >
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader
                        class="mx-auto skeleton-icon"
                        type="avatar"
                        width="60"
                        height="60"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader
                        class="mt-3 mb-4"
                        type="text"
                        width="100"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        class="mb-1"
                        type="heading"
                        width="160"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader
                        type="avatar"
                        width="150"
                        height="150"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card
                  v-else
                  min-height="210"
                  elevation="5"
                  class="stat-card deadline-card"
                >
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-clock-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-pulse">
                      <v-icon class="stat-icon">mdi-clock-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Deadline</h3>
                      <h5 class="text-white">
                        <b>{{ NpRecognitionEndDate }}</b>
                      </h5>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card
                  class="stat-card recognition-card skeleton-card"
                  v-if="CardLoadingFlag"
                  min-height="210"
                  elevation="5"
                >
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader
                        class="mx-auto skeleton-icon"
                        type="avatar"
                        width="60"
                        height="60"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader
                        class="mt-3 mb-4"
                        type="text"
                        width="100"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        class="mb-1"
                        type="heading"
                        width="70"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader
                        type="avatar"
                        width="150"
                        height="150"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card
                  v-else
                  min-height="210"
                  elevation="5"
                  class="stat-card recognition-card"
                >
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-trophy-award</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-bounce">
                      <v-icon class="stat-icon">mdi-trophy-award</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Total Recognition</h3>
                      <h1 class="stat-value counter-animate">{{ TotalRecognition }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card
                  class="stat-card applied-card skeleton-card"
                  v-if="CardLoadingFlag"
                  min-height="210"
                  elevation="5"
                >
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader
                        class="mx-auto skeleton-icon"
                        type="avatar"
                        width="60"
                        height="60"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader
                        class="mt-3 mb-4"
                        type="text"
                        width="100"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        class="mb-1"
                        type="heading"
                        width="70"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader
                        type="avatar"
                        width="150"
                        height="150"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card
                  v-else
                  min-height="210"
                  elevation="5"
                  class="stat-card applied-card"
                >
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-check-circle-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-rotate">
                      <v-icon class="stat-icon">mdi-check-circle-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Total Applied</h3>
                      <h1 class="stat-value counter-animate">{{ TotalApplied }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="3">
              <div class="stat-card-wrapper">
                <v-card
                  class="stat-card partial-card skeleton-card"
                  v-if="CardLoadingFlag"
                  min-height="210"
                  elevation="5"
                >
                  <v-card-text class="pa-6 position-relative">
                    <div class="skeleton-icon-container">
                      <v-skeleton-loader
                        class="mx-auto skeleton-icon"
                        type="avatar"
                        width="60"
                        height="60"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-content">
                      <v-skeleton-loader
                        class="mt-3 mb-4"
                        type="text"
                        width="100"
                      ></v-skeleton-loader>
                      <v-skeleton-loader
                        class="mb-1"
                        type="heading"
                        width="70"
                      ></v-skeleton-loader>
                    </div>
                    <div class="skeleton-bg-icon">
                      <v-skeleton-loader
                        type="avatar"
                        width="150"
                        height="150"
                      ></v-skeleton-loader>
                    </div>
                  </v-card-text>
                </v-card>
                <v-card
                  v-else
                  min-height="210"
                  elevation="5"
                  class="stat-card partial-card"
                >
                  <div class="stat-card-bg-icon">
                    <v-icon>mdi-content-save-outline</v-icon>
                  </div>
                  <v-card-text class="pa-6">
                    <div class="stat-icon-container animate-fade">
                      <v-icon class="stat-icon">mdi-content-save-outline</v-icon>
                    </div>
                    <div class="stat-content">
                      <h3 class="stat-title">Partially Saved</h3>
                      <h1 class="stat-value counter-animate">{{ TotalPartiallySaved }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <v-container class="table-container pb-10">
          <v-card class="tab-card" elevation="5">
            <v-tabs
              v-model="tab"
              align-with-title
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              show-arrows
              background-color="transparent"
              color="#667eea"
              slider-color="#667eea"
              centered
              height="70px"
            >
              <v-tab
                v-for="item in PortfolioDetails"
                :key="item.id"
                @click="getRecognitionDetails(item.id)"
              >
                <v-icon small>mdi-certificate</v-icon>
                {{ item.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item v-for="item in PortfolioDetails" :key="item.id">
                <v-card flat>
                  <v-card-text>
                    <v-container v-if="StartupLoadingFlag" class="pa-6">
                      <v-skeleton-loader
                        class="mx-auto"
                        type="table"
                      ></v-skeleton-loader>
                    </v-container>
                    <v-container v-if="!StartupLoadingFlag" class="pa-0">
                      <v-card class="mx-auto" elevation="0">
                        <v-data-table
                          :headers="[
                            { text: 'Approval Status', value: 'approvalStatus', sortable: false, width: '150px' },
                            { text: 'Status', value: 'status', sortable: false },
                            { text: 'Apply/Edit', value: 'apply', sortable: false },
                            { text: 'Category Title', value: 'title', sortable: true },
                            { text: 'Description', value: 'description', sortable: false },
                            { text: 'Type', value: 'type', sortable: false },
                            { text: 'Gift Name', value: 'gift', sortable: false },
                            { text: 'Actions', value: 'actions', sortable: false },
                          ]"
                          :items="tableData1"
                          :items-per-page="10"
                          class="recognition-table"
                          :footer-props="{
                            itemsPerPageText: 'Recognition per page',
                            itemsPerPageOptions: [5, 10, 15, 20],
                          }"
                        >
                          <template v-slot:[`item.approvalStatus`]="{ item }">
                            <v-chip
                              v-if="item.RecognitionApprovalStatusTxt"
                              :color="item.RecognitionApprovalStatusColor"
                              dark
                              class="font-weight-medium px-4 py-2 approval-status-chip"
                              small
                            >
                              {{ item.RecognitionApprovalStatusTxt }}
                            </v-chip>
                          </template>

                          <template v-slot:[`item.status`]="{ item }">
                            <v-chip
                              :color="item.RecognitionStatusColor"
                              dark
                              class="font-weight-medium px-4 py-2 status-chip"
                              small
                            >
                              {{ item.RecognitionStatusTxt }}
                            </v-chip>
                          </template>

                          <template v-slot:[`item.apply`]="{ item }">
                            <v-tooltip
                              bottom
                              v-if="
                                item.CreateButtonFlag &&
                                item.RecognitionStatus == 1 &&
                                StartDateFlag &&
                                EndDateFlag
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="primary"
                                  dark
                                  rounded
                                  small
                                  elevation="2"
                                  @click="addAlert(item)"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="font-weight-medium px-4 py-1 text-capitalize"
                                >
                                  <v-icon left small>mdi-file-plus</v-icon>
                                  Apply
                                </v-btn>
                              </template>
                              <span>Apply for this recognition</span>
                            </v-tooltip>

                            <v-tooltip
                              bottom
                              v-else-if="
                                item.CreateButtonFlag &&
                                item.RecognitionStatus == 1 &&
                                (!StartDateFlag || !EndDateFlag)
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="grey"
                                  dark
                                  rounded
                                  small
                                  @click="deadlineAlert"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="font-weight-medium px-4 py-1 text-capitalize"
                                >
                                  <v-icon left small>mdi-lock-clock</v-icon>
                                  Apply
                                </v-btn>
                              </template>
                              <span>Application not available at this time</span>
                            </v-tooltip>

                            <v-tooltip
                              bottom
                              v-if="
                                item.EditButtonFlag &&
                                item.RecognitionId > 0 &&
                                item.RecognitionStatus == 4 &&
                                StartDateFlag &&
                                EndDateFlag
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="amber darken-2"
                                  dark
                                  rounded
                                  small
                                  elevation="2"
                                  @click="editAlert(item, $event)"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="font-weight-medium px-4 py-1 ml-2 text-capitalize"
                                >
                                  <v-icon left small>mdi-pencil</v-icon>
                                  Edit
                                </v-btn>
                              </template>
                              <span>Edit this recognition application</span>
                            </v-tooltip>

                            <v-tooltip
                              bottom
                              v-else-if="
                                item.EditButtonFlag &&
                                item.RecognitionId > 0 &&
                                item.RecognitionStatus == 4 &&
                                (!StartDateFlag || !EndDateFlag)
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  color="grey"
                                  dark
                                  rounded
                                  small
                                  @click="deadlineAlert"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="font-weight-medium px-4 py-1 ml-2 text-capitalize"
                                >
                                  <v-icon left small>mdi-lock-clock</v-icon>
                                  Edit
                                </v-btn>
                              </template>
                              <span>Editing not available at this time</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:[`item.title`]="{ item }">
                            <div class="font-weight-medium">{{ item.CategoryTitle }}</div>
                          </template>

                          <template v-slot:[`item.description`]="{ item }">
                            <div class="text-truncate" style="max-width: 200px;">{{ item.CategoryDescription }}</div>
                          </template>

                          <template v-slot:[`item.type`]="{ item }">
                            <div class="font-weight-medium">{{ item.CategoryTypeTxt }}</div>
                          </template>

                          <template v-slot:[`item.gift`]="{ item }">
                            <div class="font-weight-medium">
                              {{ item.RecognitionGiftName ? item.RecognitionGiftName : "N/A" }}
                            </div>
                          </template>

                          <template v-slot:[`item.actions`]="{ item }">
                            <div class="action-buttons">
                              <v-tooltip bottom v-if="item.PreviewButtonFlag && item.RecognitionId > 0">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    @click="previewAlert(item, $event)"
                                    v-bind="attrs"
                                    v-on="on"
                                    class="mr-1"
                                    small
                                  >
                                    <v-icon>mdi-file-search</v-icon>
                                  </v-btn>
                                </template>
                                <span>Preview recognition details</span>
                              </v-tooltip>
                            </div>
                          </template>

                          <template v-slot:no-data>
                            <v-alert
                              type="info"
                              text
                              class="mt-3"
                              outlined
                            >
                              No recognition data available
                            </v-alert>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addRecordPrompt" persistent max-width="80%">
      <np-recognition-create
        :addRecordPrompt="addRecordPrompt"
        :recordData="selectedData"
        :recognitionDetails="rows"
        @hideAddRecordPrompt="hideAddRecordPrompt($event)"
        v-if="addRecordPrompt"
      ></np-recognition-create>
    </v-dialog>

    <v-dialog v-model="editRecordPrompt" persistent max-width="80%">
      <np-recognition-edit
        :editRecordPrompt="editRecordPrompt"
        :recordData="selectedData"
        :recognitionDetails="rows"
        @hideEditRecordPrompt="hideEditRecordPrompt($event)"
        v-if="editRecordPrompt"
      ></np-recognition-edit>
    </v-dialog>

    <v-dialog v-model="previewRecordPrompt" persistent max-width="80%">
      <np-recognition-preview
        :previewRecordPrompt="previewRecordPrompt"
        :recordData="selectedData"
        @hidePreviewRecordPrompt="hidePreviewRecordPrompt($event)"
        v-if="previewRecordPrompt"
      ></np-recognition-preview>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import NpRecognitionCreate from "@/view/pages/erp/jci-award/np-recognition/NpRecognitionCreate.vue";
import NpRecognitionEdit from "@/view/pages/erp/jci-award/np-recognition/NpRecognitionEdit.vue";
import NpRecognitionPreview from "@/view/pages/erp/jci-award/np-recognition/NpRecognitionPreview.vue";

export default {
  mixins: [common],
  components: {
    NpRecognitionCreate,
    NpRecognitionEdit,
    NpRecognitionPreview,
  },
  data() {
    return {
      tab: null,

      NpRecognitionStartDate: "",
      NpRecognitionEndDate: "",
      TotalRecognition: 0,
      TotalApplied: 0,
      TotalPartiallySaved: 0,

      StartDateFlag: false,
      EndDateFlag: false,

      CurrentDateTime: "",
      CurrentDate: "",
      CurrentTime: "",
      CurrentAmPm: "",

      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,
      OverlayLoadingFlag: false,
      CardLoadingFlag: false,

      ProgessStart: 0,
      uploadPercentage: 0,

      PortfolioDetails: [
        { id: 1, name: "NA" },
        { id: 2, name: "Program" },
        { id: 3, name: "Business" },
        { id: 4, name: "Training" },
        { id: 5, name: "Management" },
        { id: 6, name: "G&D" },
        { id: 7, name: "Internationalism" },
        { id: 8, name: "IT Wing" },
        { id: 9, name: "Junior Jaycee Wing" },
        { id: 10, name: "Jayceert Wing" },
        { id: 11, name: "Bulletin" },
        { id: 12, name: "Officer" },
        { id: 13, name: "PR & MARKETING" },
      ],

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],

      LomCodeRules: [(v) => !!v || "LO is required"],
      LomCode: 0,
      LomCodeOptions: [],

      rows: [],
      tableData1: [],
      tableOptions1: [],
      tableColumns1: [],

      recordData: {},
      selectedData: {},

      addRecordPrompt: false,
      editRecordPrompt: false,
      previewRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: 0,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
    rows: function () {
      console.log("watch rows called");
      this.getCurrentDateTime();
    },
    CurrentDateTime: function () {
      console.log("watch CurrentDateTime called");
      this.getDeadlineDetails();
    },
    // ZoneCodeOptions: function () {
    //   console.log("watch ZoneCodeOptions");
    //   this.ZoneCodeOptionsLoading = false;
    // },
    // LomCodeOptions: function () {
    //   console.log("watch LomCodeOptions");
    //   this.LomCodeOptionsLoading = false;
    // },
    // ZoneCode: function () {
    //   console.log("watch ZoneCode");

    //   this.LomAward = [];
    //   this.getLomCodeOptions();
    // },
    // LomCode: function () {
    //   console.log("watch LomCode");

    //   this.getAwardTypeDetails();
    // },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "np_recognition",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getRecognitionDetails(1);
      this.getTotalRecognitionDetails();
    },
    getCurrentDateTime() {
      console.log("getCurrentDateTime called");

      // Get new date
      var dateObj = new Date();

      var temp_date = String(dateObj.getDate()).padStart(2, "0");
      var month = String(dateObj.getMonth() + 1).padStart(2, "0");
      var year = dateObj.getFullYear();

      // Get Current Date
      var current_date = year + "-" + month + "-" + temp_date;

      // var temp_hour = String(dateObj.getHours()).padStart(2, "0") % 12;
      // var hour = temp_hour ? temp_hour : 12;
      var hour = String(dateObj.getHours()).padStart(2, "0");
      var minute = String(dateObj.getMinutes()).padStart(2, "0");
      var second = String(dateObj.getSeconds()).padStart(2, "0");

      // Get Current Time
      var current_time = hour + ":" + minute + ":" + second;

      // Get Current AM/PM
      // var current_am_pm = dateObj.getHours() >= 12 ? "pm" : "am";

      console.log({ current_date }, { current_time });

      this.CurrentDate = current_date;
      this.CurrentTime = current_time;
      // this.CurrentAmPm = current_am_pm;

      var current_date_time = current_date + " " + current_time;

      this.CurrentDateTime = current_date_time;
    },
    getDeadlineDetails() {
      console.log("getDeadlineDetails called");

      // this.CurrentDateTime = "2023-08-01 23:00:00";
      var current_date_time = Date.parse(this.CurrentDateTime);
      console.log({ current_date_time });

      var tr = this.rows;

      // Np-Recognition Start Date
      var temp_start_date_time = tr.StartDate1;
      // temp_start_date_time = "2023-08-01 00:00:01"
      var start_date_time = Date.parse(temp_start_date_time);
      console.log({ temp_start_date_time }, { start_date_time });

      if (start_date_time <= current_date_time) {
        console.log("Opened");
        this.StartDateFlag = true;
      } else {
        console.log("Closed");
      }

      // Np-Recognition End Date

      var temp_end_date_time = tr.EndDate1;
      var end_date_time = Date.parse(temp_end_date_time);
      console.log({ temp_end_date_time }, { end_date_time });

      if (end_date_time > current_date_time) {
        console.log("Opened");
        this.EndDateFlag = true;
      } else {
        console.log("Closed");
      }
    },
    deadlineAlert() {
      console.log("deadlineAlert called");
      var htmlTxt = "";
      htmlTxt += "<h3> NP-Recognition Apply will be";
      htmlTxt += "<br/> Start <b> " + this.NpRecognitionStartDate + " and </b>";
      htmlTxt += "<br/> End <b> " + this.NpRecognitionEndDate + " </b> </h3>";

      Swal.fire({
        title: "Sorry !",
        text: "",
        icon: "warning",
        html: htmlTxt,
      });
    },
    reset() {
      console.log("reset called");
      this.$refs.form.reset();
      this.AllMempership = [];
      this.AllTitles = [];
      this.AllProgramme = [];
      this.AllIncome = [];
      this.AllExpenses = [];
      this.AllProject = [];
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form.resetValidation();
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var selectbox1_source = "ZoneCode";
      var selectbox1_destination = "ZoneCodeOptions";
      var selectbox1_url = "api/year-wise-lom/zone-options";
      var selectbox1_conditions_array = {
        UserInterface: 4,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      if (ZoneCode != "") {
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        message += "Zone should not be empty. ";
      }
    },
    getRecognitionDetails(id) {
      console.log("getRecognitionDetails called");
      console.log({ id });

      if (id > 0) {
        this.SubmitFlag = true;
        this.StartupLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/recognition-category/lists";

        var upload = {
          UserInterface: 2,
          Portfolio: id,
        };

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.tableData1 = [];
        this.tableOptions1 = [];
        this.tableColumns1 = [];

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.StartupLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.tableOptions1 = records.TableOptions;

            if (flag == 1) {
              thisIns.SubmitFlag = false;
              console.log({ records });

              thisIns.tableData1 = records.TableData;
              console.log("tableData1 = " + JSON.stringify(thisIns.tableData1));

              thisIns.toast("success", output);
            } else {
              thisIns.SubmitFlag = false;
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.StartupLoadingFlag = false;
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    getTotalRecognitionDetails() {
      console.log("getTotalRecognitionDetails called");

      var validate1 = true;
      console.log({ validate1 });

      if (validate1) {
        this.CardLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/recognition-category/total-recognition";

        var upload = {
          UserInterface: 1,
        };

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.CardLoadingFlag = false;

            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              console.log("records = " + JSON.stringify(records));
              thisIns.rows = records;

              thisIns.NpRecognitionStartDate = records.StartDateTxt;
              thisIns.NpRecognitionEndDate = records.EndDateTxt;
              thisIns.TotalRecognition = records.TotalRecognition;
              thisIns.TotalApplied = records.TotalApplied;
              thisIns.TotalPartiallySaved = records.TotalPartiallySaved;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            thisIns.CardLoadingFlag = false;
            console.log("error=" + error);
            thisIns.toast("error", error);
          });
      } else {
        var message = "";
        console.log("error=" + message);
      }
    },
    addAlert(tr) {
      console.log("addAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.addRecordPrompt = true;
      }
    },
    hideAddRecordPrompt(flag) {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
      console.log({ flag });
      var id = this.selectedData.PortfolioId;
      if (flag) {
        this.getRecognitionDetails(id);
        this.getTotalRecognitionDetails();
      }
    },
    previewAlert(tr) {
      console.log("previewAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.previewRecordPrompt = true;
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hidePreviewRecordPrompt() {
      console.log("hidePreviewRecordPrompt called");
      this.previewRecordPrompt = false;
    },
    editAlert(tr) {
      console.log("editAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.editRecordPrompt = true;
        // this.$router.push("/zonecon/lom-award/edit?id=" + id);
      } else {
        var message = "Kindly select one record to preview";
        this.errorMessage(message);
      }
    },
    hideEditRecordPrompt(flag) {
      console.log("hideEditRecordPrompt called");
      this.editRecordPrompt = false;
      console.log({ flag });
      var id = this.selectedData.PortfolioId;
      if (flag) {
        this.getRecognitionDetails(id);
        this.getTotalRecognitionDetails();
      }
    },
    deleteAlert(tr) {
      console.log("deleteAlert called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        this.selectedData = tr;
        var id = tr.AwardId;
        console.log({ id });
        if (id > 0) {
          this.confirmAlert();
        }
      } else {
        var message = "Kindly select one record to edit";
        this.errorMessage(message);
      }
    },
    confirmAlert() {
      console.log("confirmAlert called");
      var tr = this.selectedData;
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));

      if (n1 > 0) {
        var htmlTxt = "";
        htmlTxt += "<br/>Award Group <b> " + tr.AwardGroupDisplayText + "</b>";
        htmlTxt += "<br/> Award Name <b> " + tr.AwardTypeTitle + "</b>";
        htmlTxt += "<br/>Award Status <b> " + tr.AwardStatusTxt + "</b>";
        htmlTxt += "<br/><br/>Do you want to delete the data?";

        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to delete the data?",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Delete`,
          confirmButtonColor: "#d33",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteRecord(tr);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
    deleteRecord(tr) {
      console.log("deleteRecord called");

      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      console.log({ tr });

      if (n1 > 0 && this.RoleId == 2) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/destroy";

        var upload = {
          UserInterface: 1,
          Award: tr.AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.getAwardTypeDetails();
              this.getTotalRecognitionDetails();
              thisIns.sweetAlert("success", output, false);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "Kindly select one record to delete";
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
#np-recognition-list {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px;

  .main-card {
    border-radius: 15px !important;
    overflow: hidden;
    background: white;
  }

  // Header Styles
  .header-container {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 30px !important;
    color: white;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }

    .header-title {
      position: relative;
      z-index: 1;

      h2 {
        color: white;
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        margin-bottom: 8px;
      }

      .header-bar {
        width: 100px;
        height: 4px;
        background: linear-gradient(90deg, #fff 0%, rgba(255, 255, 255, 0.3) 100%);
        border-radius: 2px;
      }
    }

    .action-btn {
      position: relative;
      z-index: 1;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3) !important;
      }
    }
  }

  // Stats Container
  .stats-container {
    padding: 30px 20px !important;
  }

  .stat-card-wrapper {
    height: 100%;
  }

  .stat-card {
    border-radius: 15px !important;
    position: relative;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15) !important;
    }

    &.deadline-card {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
    }

    &.recognition-card {
      background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      color: white;
    }

    &.applied-card {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
      color: white;
    }

    &.partial-card {
      background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
      color: white;
    }

    &.skeleton-card {
      background: #f5f5f5;
    }

    .stat-card-bg-icon {
      position: absolute;
      right: -20px;
      bottom: -20px;
      opacity: 0.15;
      transform: rotate(-15deg);

      .v-icon {
        font-size: 150px !important;
        color: white;
      }
    }

    .stat-icon-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 70px;
      height: 70px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 15px;
      margin-bottom: 20px;
      backdrop-filter: blur(10px);

      .stat-icon {
        font-size: 36px !important;
        color: white;
      }

      &.animate-pulse {
        animation: pulse 2s ease-in-out infinite;
      }

      &.animate-bounce {
        animation: bounce 2s ease-in-out infinite;
      }

      &.animate-rotate {
        animation: rotate 3s linear infinite;
      }

      &.animate-fade {
        animation: fade 2s ease-in-out infinite;
      }
    }

    .stat-content {
      position: relative;
      z-index: 1;

      .stat-title {
        font-size: 12px;
        font-weight: 600;
        opacity: 0.95;
        margin-bottom: 12px;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        color: rgba(255, 255, 255, 0.95);
      }

      .stat-value {
        font-size: 42px;
        font-weight: 800;
        line-height: 1.2;
        text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2);
        color: #ffffff;

        &.counter-animate {
          animation: countUp 0.5s ease-out;
        }
      }
    }

    // Skeleton Loader Styles
    .skeleton-icon-container {
      margin-bottom: 20px;

      .skeleton-icon {
        border-radius: 15px !important;
      }
    }

    .skeleton-content {
      position: relative;
      z-index: 1;
    }

    .skeleton-bg-icon {
      position: absolute;
      right: -20px;
      bottom: -20px;
      opacity: 0.1;
    }
  }

  // Table Container
  .table-container {
    padding: 20px !important;
  }

  .tab-card {
    border-radius: 15px !important;
    overflow: hidden;
  }

  // Tabs Styling
  ::v-deep .v-tabs {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;

    .v-tab {
      text-transform: none !important;
      font-weight: 600 !important;
      font-size: 15px !important;
      letter-spacing: 0.5px !important;
      color: #495057 !important;
      transition: all 0.3s ease !important;
      min-height: 70px !important;

      &:hover {
        background-color: rgba(102, 126, 234, 0.1) !important;
        color: #667eea !important;
      }

      &.v-tab--active {
        color: #667eea !important;
        font-weight: 700 !important;
      }

      .v-icon {
        color: #667eea !important;
        margin-right: 8px !important;
      }
    }

    .v-tabs-slider {
      background-color: #667eea !important;
      height: 3px !important;
    }
  }

  // Data Table Styling
  .recognition-table {
    ::v-deep .v-data-table__wrapper {
      border-radius: 10px;
      overflow: hidden;
    }

    ::v-deep thead {
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

      th {
        font-weight: 700 !important;
        font-size: 13px !important;
        color: #495057 !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border-bottom: 2px solid #dee2e6 !important;
      }
    }

    ::v-deep tbody {
      tr {
        transition: all 0.2s ease;

        &:hover {
          background-color: #f8f9fa !important;
          transform: scale(1.01);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        }

        td {
          padding: 16px !important;
          font-size: 14px;
          color: #495057;
        }
      }
    }

    .status-chip {
      border-radius: 20px !important;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }

    .approval-status-chip {
      border-radius: 20px !important;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .action-buttons {
      display: flex;
      gap: 8px;

      .v-btn {
        transition: all 0.2s ease;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }

  // Animations
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
  }

  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes fade {
    0%, 100% {
      opacity: 0.9;
    }
    50% {
      opacity: 0.5;
    }
  }

  @keyframes countUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // Responsive Design
  @media (max-width: 960px) {
    .header-container {
      padding: 20px !important;

      .header-title h2 {
        font-size: 1.5rem !important;
      }
    }

    .stats-container {
      padding: 15px !important;
    }

    .stat-card {
      min-height: 180px !important;

      .stat-content .stat-value {
        font-size: 28px;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 10px;

    .header-container {
      .action-btn {
        min-width: auto !important;
        padding: 0 16px !important;
      }
    }

    .stat-card {
      min-height: 160px !important;

      .stat-icon-container {
        width: 60px;
        height: 60px;

        .stat-icon {
          font-size: 28px !important;
        }
      }

      .stat-content {
        .stat-title {
          font-size: 12px;
        }

        .stat-value {
          font-size: 24px;
        }
      }
    }
  }
}
</style>
